import React, { useState, useEffect, useRef } from 'react';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';

import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { setUpdatedModule, updateCompanySettingsAsyncThunk } from '../../../store/modules/moduleSlice';
import { setProgramReq, setWebservicesReq, setLoginSuccess, setLoginToken } from '../../../store/modules/bilsoftSlice';
import { getCompaniesByUserAsyncThunk } from '../../../store/company/userCompanySlice';

import WebServicesReq from './components/WebServicesReq';
import ProgramReq from './components/ProgramReq';
import { loginBilsoft } from './utils/bilsoftRequest';

export default function UpdateBilsoft() {
    const { updatedModule } = useSelector((state) => state.modules);
    const { selectedCompany } = useSelector((state) => state.userCompany);
    const { webServiceReq, programReq } = useSelector((state) => state.bilsoft);

    const [pending, setPending] = useState(false);

    const dispatch = useDispatch();
    const location = useLocation();
    const toast = useRef(null);

    useEffect(() => {
        let path = location.pathname.split('/')[1];
        let module = selectedCompany?.modules.find((item) => item.title === path);
        dispatch(setUpdatedModule(module));
    }, [location.pathname, selectedCompany?.modules, dispatch]);

    useEffect(() => {
        if (updatedModule) {
            // Initialize with existing data
            if (updatedModule.setting?.settings?.program?.requirements?.[0]) {
                dispatch(setProgramReq(updatedModule.setting.settings.program.requirements[0]));
            }
            if (updatedModule.setting?.settings?.webService?.requirements) {
                dispatch(setWebservicesReq(updatedModule.setting.settings.webService.requirements));
            }
        }
    }, [updatedModule, dispatch]);

    const save = async () => {
        try {
            // First, attempt bilsoft login to validate credentials
            const loginResponse = await loginBilsoft(programReq.taxNumber, programReq.databaseId, programReq.period, programReq.username, programReq.password, programReq.apiUsername, programReq.apiPassword);

            if (loginResponse.data.success && loginResponse.data.data.token) {
                // Login successful, update the module settings
                dispatch(setLoginSuccess(true));
                dispatch(setLoginToken(loginResponse.data.data.token));

                toast.current.show({
                    severity: 'success',
                    summary: 'Başarılı',
                    detail: 'Bilsoft girişi başarılı',
                    life: 2000
                });

                const data = {
                    companyId: selectedCompany.id,
                    moduleId: updatedModule.id,
                    settings: {
                        moduleId: updatedModule.id,
                        title: updatedModule.title,
                        program: {
                            _id: updatedModule.setting.settings.program._id,
                            title: updatedModule.setting.settings.program.title,
                            requirements: [programReq]
                        },
                        webService: {
                            requirements: webServiceReq,
                            _id: updatedModule.setting.settings.webService._id,
                            title: updatedModule.setting.settings.webService.title,
                            url: updatedModule.setting.settings.webService.url
                        },
                        bilsoftToken: loginResponse.data.data.token,
                        bilsoftExpiration: loginResponse.data.data.expiration
                    }
                };

                setPending(true);
                await dispatch(updateCompanySettingsAsyncThunk(data));
                await dispatch(getCompaniesByUserAsyncThunk());

                toast.current.show({
                    severity: 'success',
                    summary: 'Başarılı',
                    detail: 'Modül Güncellendi',
                    life: 1500
                });

                setTimeout(() => {
                    setPending(false);
                    window.location.reload();
                }, 1500);
            } else {
                toast.current.show({
                    severity: 'error',
                    summary: 'Hata',
                    detail: 'Bilsoft girişi başarısız - Lütfen bilgilerinizi kontrol edin',
                    life: 3000
                });
            }
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Hata',
                detail: error?.response?.data?.message || 'Bir hata oluştu',
                life: 3000
            });
        }
    };

    const programReqState = () => {
        return programReq?.taxNumber && programReq?.databaseId && programReq?.period && programReq?.username && programReq?.password && programReq?.apiUsername && programReq?.apiPassword;
    };

    const webServiceReqState = () => {
        return webServiceReq && Object.keys(webServiceReq).every((key) => webServiceReq[key]);
    };

    const isDisabled = () => {
        if (programReqState() && webServiceReqState()) {
            return false;
        }
        return true;
    };

    return (
        <>
            <Toast ref={toast} />
            <div className="flex align-items-center">
                <Button className="" icon="pi pi-building" />
                <h3 className="mb-4 ml-3">{selectedCompany?.name}</h3>
            </div>
            <div className="card">
                <div className="">
                    <div className="flex flex-column md:flex-row">
                        <div className="w-full">
                            <ProgramReq req={programReq} />
                        </div>

                        <div className="w-full md:w-1">
                            <Divider layout="vertical" className="hidden md:flex"></Divider>
                        </div>

                        <WebServicesReq req={webServiceReq} title={updatedModule?.setting?.settings?.webService?.title} />
                    </div>
                </div>

                <div className="text-center mt-5">
                    <Button label="Güncelle" icon="pi pi-check" className="p-button-success text-white p-mr-2 px-6" onClick={() => save()} disabled={isDisabled()} loading={pending} />
                </div>
            </div>
        </>
    );
}
